<script lang="ts">
	import AuthorAvatar from '$lib/components/blog/article/AuthorAvatar.svelte';
	import { onMount } from 'svelte';
	import { getAuthorAvatar_url } from '$lib/user';
	import { getBlogAvatarUrl } from '$lib/services/avatarService';

	export let created_by;
	export let author;
	export let location;
	let avatar_url: string;
	let resolved_avatar_url: string;

	const updateAvatar_url = async () => {
		let id = created_by;
		// console.log('id', id);

		// Only fetch avatar if we have a valid ID
		if (id && id.trim() !== '') {
			avatar_url = await getAuthorAvatar_url(id);
			resolved_avatar_url = await getBlogAvatarUrl(avatar_url, id);
			// console.log('avatar_url api', avatar_url);
		} else {
			resolved_avatar_url = '';
		}
	};

	onMount(() => {
		updateAvatar_url();
	});
</script>

<div class="flex pb-3 md:pb-4 items-center">
	<div class="-ml-2 inline-block mr-4 w-6 h-6 my-auto transition ease-in delay-300 mt-0">
		{#if resolved_avatar_url}
			<AuthorAvatar avatar_url={resolved_avatar_url} alt={'...'} />
		{:else}
			<!-- Optionally, you can display a loading indicator or placeholder -->
			<p class="w-6 h-6 bg-cosmicPurple600 opacity-60 rounded-full"></p>
		{/if}
	</div>
	<div class="flex my-auto ml-2">
		<!-- maybe TODO later: hyperlink this image to their blog page? -->
		<div class="grid grid-rows-2 text-gradientBlue capitalize font-medium my-auto">
			<div class="text-sm">{author}</div>
			<div class="text-sm">{location}</div>
		</div>
	</div>
</div>
